export default [
    {
        title: 'menu.tiers.tiers',
        icon: ['fal', 'user-tie'],
        accessRights: 'MVP',
        children: [
            {
                title: 'menu.tiers.tous_les_tiers',
                icon: ['fal', 'users'],
                to: { name: 'tiersListe' },
                href: '#/tiers',
                accessRights: 'TIERS|FACT|REPRO'
            },
            {
                title: 'menu.tiers.tous_les_tiers_online',
                icon: ['fal', 'users'],
                to: { name: 'tiersListeOnline' },
                href: '#/tiers_online',
                accessRights: 'TIERS|FACT|REPRO'
            },
			{
                title: 'menu.tiers.tiers_archived',
                icon: ['fal', 'users'],
                to: { name: 'tiersArchivedListe' },
                href: '#/tiers_archived',
                accessRights: 'TIERS|FACT|REPRO'
            },
            {
                title: 'global.recherche',
                icon: ['fal', 'search'],
                to: { name: 'tiersSearchQualification' },
                href: '#/tiers/search/qualif',
                accessRights: 'TIERS|FACT'
            },
			{
                title: 'menu.tiers.tous_les_contacts',
                icon: ['fal', 'search'],
                to: { name: 'contactList' },
                href: '#/contacts',
                accessRights: 'MVP'
            },
            {
                title: 'menu.tiers.contacts_archived',
                icon: ['fal', 'search'],
                to: { name: 'contactArchivedList' },
                href: '#/contacts_archived',
                accessRights: 'MVP'
            },
            {
				title: 'horse.ajouter_tiers_horse',
				icon: ['fal', 'plus'],
				to: { name: 'tiersAjout' },
                accessRights: 'TIERS|FACT'
			},
            {
                title: 'sync_groomy.demandes',
                icon: ['fal', 'link'],
                to: { name: 'syncGroomy' },
                accessRights: 'LICADM|SYNCGRM'
            }
        ]
    },
    {
        title: 'menu.facturation.facturation',
        icon: ['fal', 'file-invoice'],
        accessRights: 'FACT|FOUROCR',
        children: [
            {
                title: 'invoice.control_properties',
                accessRights: 'FACT',
                icon: ['far', 'list-ul'],
                to: { name: 'controlProperties' },
                href: '#/control_properties'
            },
            {
                title: 'menu.facturation.generer_facture',
                icon: ['fal', 'file-export'],
                to: { name: 'invoiceAValider' },
                href: '#/invoice/a_valider',
                accessRights: 'FACT'
            },
            {
                title: 'menu.facturation.bon_facturer',
                icon: ['fal', 'file-invoice'],
                to: { name: 'invoiceBons' },
                href: '#/invoice/bons',
                accessRights: 'FACT'
            },
            {
                title: 'menu.facturation.factures',
                icon: ['fal', 'file-invoice'],
                to: { name: 'invoiceList' },
                href: '#/invoice/list',
                accessRights: 'FACT'
            },
            {
                title: 'menu.facturation.reglements',
                icon: ['fal', 'money-check-edit-alt'],
                to: { name: 'paymentList' },
                href: '#/payments/list',
                accessRights: 'FACT'
            },
            {
                title: 'menu.facturation.impayes',
                icon: ['fal', 'receipt'],
                to: { name: 'impayesList' },
                href: '#/invoice/unpaid',
                accessRights: 'FACT'
            },
            {
                title: 'menu.facturation.quotation',
                accessRights: 'DEVIS',
                icon: ['far', 'signature'],
                to: { name: 'quotation' },
                href: '#/quotation'
            },
            {
                title: 'menu.facturation.bilan',
                icon: ['fal', 'receipt'],
                to: { name: 'InvoiceResults' },
                href: '#/invoice/results',
                accessRights: 'FACT'
            },
            {
                title: 'menu.facturation.regul_bancaire',
                accessRights: 'FACT&MULTICOMPTA',
                icon: ['fal', 'arrows-alt-h'],
                to: { name: 'regulBancaire' },
                href: '#/payments/regul'
            },
            {
                title: 'menu.facturation.export_deb_des',
                accessRights: 'DEBDES',
                icon: ['fal', 'download'],
                to: { name: 'exportDES' },
                href: '#/export_des'
            },
            {
                title: 'menu.facturation.balance_account',
                accessRights: 'FACT',
                icon: ['fal', 'money-check-edit-alt'],
                to: { name: 'balanceAccount' },
                href: '#/payments/balanceAccount'
            }
        ]
    },
    {
        // Domaine fournisseurs, à côté de la facturation et non dedans : les factures reçues n'y
        // seront bientôt plus seules — référentiel d'articles, suivi des tarifs pratiqués.
        title: 'menu.fournisseurs.fournisseurs',
        icon: ['fad', 'truck'],
        accessRights: 'FOUROCR',
        children: [
            {
                title: 'menu.fournisseurs.factures',
                icon: ['fal', 'file-invoice'],
                accessRights: 'FOUROCR',
                to: { name: 'invoiceSupplierControl' },
                href: '#/invoice_supplier/inbox'
            },
            {
                // Les règlements ne sont plus un onglet des factures : ils se consultent par
                // fournisseur et par période, indépendamment de l'avancement d'une facture.
                title: 'menu.fournisseurs.reglements',
                icon: ['fal', 'money-check-edit-alt'],
                accessRights: 'FOUROCR',
                to: { name: 'invoiceSupplierPayment' },
                href: '#/invoice_supplier/payment'
            },
            {
                // Ce qui reste à imputer en comptabilité. Cette vue ne figure pas parmi les onglets de
                // suivi : elle les recoupe tous — une facture soldée peut n'avoir jamais été ventilée —
                // et se consulte pour elle-même, par période.
                title: 'menu.fournisseurs.a_ventiler',
                icon: ['fal', 'list-ul'],
                accessRights: 'FOUROCR',
                to: { name: 'invoiceSupplierToAllocate' },
                href: '#/invoice_supplier/to-allocate'
            },
            {
                // Suite de la précédente : une fois approuvée et ventilée, la facture attend d'être
                // transmise en comptabilité, et y reste tant qu'elle n'est pas cochée « Comptabilisé ».
                title: 'menu.fournisseurs.export_comptable',
                icon: ['fal', 'file-export'],
                accessRights: 'FOUROCR',
                to: { name: 'invoiceSupplierToExport' },
                href: '#/invoice_supplier/to-export'
            }
        ]
    },
    {
        // Domaine bancaire, sorti de la facturation : le rapprochement part du relevé et non d'une
        // facture, et il concerne autant les encaissements clients que les règlements fournisseurs.
        // Il n'y sera bientôt plus seul — soldes des comptes, suivi des connexions bancaires.
        title: 'menu.banque.banque',
        icon: ['fal', 'credit-card'],
        accessRights: 'FLUX',
        children: [
            {
                title: 'menu.banque.flux',
                icon: ['far', 'list-ul'],
                accessRights: 'FLUX',
                to: { name: 'bankFlow' },
                href: '#/bank/flow'
            }
        ]
    }
]
